export class ClientSideError extends Error {
	constructor(message: string) {
		const msg: string = `<ClientSideError> this code should be evaluated on client side only: "${message}".`;
		super(msg);
		this.name = 'Client Side Error';
	}
}
